"use client"

import { useDispatch, useSelector } from "react-redux"
import ComponentBusinessAssignedArea from "./ComponentBusinessAssignedArea"
import { RootState } from "../../../store"
import { addBusinessArea, removeBusinessArea } from "../../../store/slices/businessAreasSlice"
import Image from "../../images/Image"
import useTranslation from "../../CustomHooks/useTranslation"
import { inputFieldContent } from "../../inputfields/InputFieldContent"

export default function MainBusinessAssignedArea() {
  const dispatch = useDispatch()
  const { translate } = useTranslation(inputFieldContent)
  const businessAreas = useSelector((state: RootState) => state.businessAreas.areas)

  const handleAddBusinessArea = () => {
    dispatch(addBusinessArea())
  }

  const handleRemoveBusinessArea = (id: number) => {
    dispatch(removeBusinessArea(id))
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-primary underline pt-8 pb-4">{translate('Business Assigned Area')}</h1>
      {businessAreas.map((area,index) => (
        <ComponentBusinessAssignedArea
          key={area.id}
          id={area.id}
          onDelete={() => handleRemoveBusinessArea(area.id)}
          showDelete={businessAreas.length > 1}
          index={index}
        />
      ))}
      {businessAreas.length < 2 && (
        <div>
          <div className="flex items-center cursor-pointer text-primary w-fit" onClick={handleAddBusinessArea}>
            <Image src="plus" className="h-5 w-5 mr-2" testId="add-business-area" />
            <p className="text-body1">{translate(`Add (You can add 1 more business assigned area)`)}</p>
          </div>
        </div>
      )}
    </div>
  )
}

